import { th, variants } from 'style/theme';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const ErrorMessageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-start;
  font-size: 14px;
  color: ${th('colors.fuzzyWuzzyBrown')};
`;

export const InputWrapper = styled.div`
  position: relative;
  outline: none;
  border: none;
`;

const grayVariant = css`
  background-color: ${th(`colors.pickledBluewood4`)};
`;

const fountainBlueVariant = css`
  background-color: ${th(`colors.fountainBlue+4`)};
`;

const whiteVariant = css`
  background-color: ${th(`colors.white`)};
  :focus {
    outline: 4px solid ${th('colors.inputs.white.outline')};
    border: 1px solid ${th('colors.inputs.white.border')};
  }
`;

export const customInputStyle = css`
  border-radius: 16px;
  padding: 8px 12px;
  padding-top: 26px;
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  font-family: Inter;
  height: 56px;
  color: ${th('colors.pickledBluewood')};

  ::placeholder {
    font-size: 16px;
    color: ${th('colors.pickledBluewood2')};
    margin: 0;
  }

  ${variants('variant', {
    gray: grayVariant,
    fountainBlue: fountainBlueVariant,
    white: whiteVariant
  })};
`;

export const Input = styled.input`
  ${customInputStyle};

  ${({ isFieldValid }) =>
    !isFieldValid &&
    css`
      background-color: ${th('colors.fuzzyWuzzyBrown+4')};
      border: 1px solid ${th('colors.fuzzyWuzzyBrown')};
      outline: 4px solid rgb(199, 99, 88, 0.5);

      :focus {
        background-color: ${th('colors.fuzzyWuzzyBrown+4')};
        border: 1px solid ${th('colors.fuzzyWuzzyBrown')};
        outline: 4px solid rgb(199, 99, 88, 0.5);
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.75;
    `}
`;

export const Label = styled.label`
  position: absolute;
  left: 12px;
  top: 8px;
  font-size: 12px;
  line-height: 16px;
  color: ${th('colors.osloGray')};
  margin: 0;
  pointer-events: none;

  ${({ isFieldValid }) =>
    !isFieldValid &&
    css`
      color: ${th('colors.fuzzyWuzzyBrown')};
    `}
`;

export const Icon = styled.img`
  position: absolute;
  right: 20px;
  top: 16px;
  width: 20px;
  height: 20px;
`;
